/**
 * Display + dial helpers for stored phone numbers (PD-1133).
 *
 * Stored shapes vary by intake path: the doctor console writes E.164
 * (`+16462204565`), patient-web registration writes `(646) 220-4565`.
 * Display drops the +1 country code per product: `646-220-4565`.
 */

/** `646-220-4565` for US 10/11-digit numbers; anything else returned unchanged. */
export function formatPhoneDisplay(raw: string | undefined | null): string {
  if (!raw) return ''
  const digits = raw.replace(/\D/g, '')
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
  if (national.length !== 10) return raw
  return `${national.slice(0, 3)}-${national.slice(3, 6)}-${national.slice(6)}`
}

/** `tel:` href — E.164 for US numbers so dialing works from any locale. */
export function phoneHref(raw: string | undefined | null): string {
  if (!raw) return ''
  const digits = raw.replace(/\D/g, '')
  // Already international (E.164) — keep the `+` (a bare-digits tel: URI is an
  // invalid "local-number" and dials wrong for non-US country codes).
  if (raw.trim().startsWith('+')) return `tel:+${digits}`
  if (digits.length === 10) return `tel:+1${digits}`
  if (digits.length === 11 && digits.startsWith('1')) return `tel:+${digits}`
  return `tel:${digits}`
}
